import { styled } from '@linaria/react';
// intl-next Link не совместим с linaria. Не критично, при необходимости стилизовать дочерений <a> вместо Link
// eslint-disable-next-line no-restricted-imports
import Link from 'next/link';

export const StyledLink = styled(Link)`
	svg {
		width: 24px;
		height: 24px;
	}
`;
